import React, { useState } from "react"
import * as layouts from "layouts"
import * as archetype from "."
import * as brandguide from "brandguide"
import * as md5x from "md5x"

export const Steps = {
	SELECTION: 0,
	BREAKDOWN: 1,
	RESULT: 2,
}

export function Container(props: layouts.containers.ContainerProps): JSX.Element {
	const { ...rest } = props
	const cache = brandguide.cache.useCached()

	const _archetype = brandguide.api.zeros.guide.guideArchetypeZero(cache.guide.guide?.archetype)

	const curstep = () => {
		switch (false) {
			case brandguide.validations.archetype.valid.selection(_archetype):
				return Steps.SELECTION
			case brandguide.validations.archetype.valid.breakdown(_archetype):
				return Steps.BREAKDOWN
			default:
				return Steps.RESULT
		}
	}

	const [step, setStep] = useState(curstep)
	const [loading, setLoading] = useState(false)

	const handleOnStep = (step: number, data: brandguide.api.GuideArchetype | undefined) => {
		if (!data) {
			setStep(step)
			return
		}

		const guide = { ...cache.guide.guide, archetype: data }
		const md5 = md5x.string(JSON.stringify(guide))

		if (md5 === cache.md5) {
			setStep(step)
			return
		}

		setLoading(true)
		cache.store({ ...cache, guide: { ...cache.guide, guide: guide } }).finally(() => {
			setStep(step)
			setLoading(false)
		})
	}

	return (
		<layouts.Flex overflowY="auto" {...rest}>
			<layouts.loading.screen flex="1" loading={loading}>
				{step === Steps.SELECTION && <archetype.Selection onChange={handleOnStep} />}
				{step === Steps.BREAKDOWN && <archetype.BreakDown onChange={handleOnStep} />}
				{step === Steps.RESULT && <archetype.Result onChange={handleOnStep} />}
			</layouts.loading.screen>
		</layouts.Flex>
	)
}

Container.defaultProps = {
	flexDirection: "column",
	flex: "1",
	mb: "25px",
}

export default Container
